import * as React from 'react';

import { SelectField, SelectOption } from '@coursera/cds-core';

import { getAvailableLocalesForUser } from 'bundles/common/utils/localeUtils';

import _t from 'i18n!nls/account-settings';

type Props = {
  value: string;
  onChange: (event: React.ChangeEvent<{ name?: string; value: unknown }>) => void;
};

const LanguageSelect = ({ value, onChange }: Props) => {
  const locales = getAvailableLocalesForUser();
  const selected = locales.find((locale) => locale.key === value) ? value : '';

  return (
    <SelectField
      data-testid="settings-basic-language"
      label={_t('Language')}
      name="locale"
      value={selected}
      onChange={onChange}
      placeholder={_t('Select a language')}
      optional
      necessityIndicator="none"
      fullWidth
    >
      {locales.map(({ key, label }) => (
        <SelectOption key={key} value={key}>
          {label}
        </SelectOption>
      ))}
    </SelectField>
  );
};

export default LanguageSelect;
